import { Component, OnInit } from '@angular/core';
import { DataManagementAppService } from 'src/app/services/data-management-app.service';

interface Module {
  key: string;
  tabName: string;
  tabRoute: string;
  buttonName: {
    btnName: string;
    btnRoute: string;
    dataName: string;
    fileCount?: number;
    updatedDtm?: string;
  }[];
}

@Component({
  selector: 'app-configure-data-source',
  template: `
    <div class="w-full min-h-[calc(100vh-2rem)]" style="padding: 26px 28px 44px">
      <header class="mb-5">
        <h1 class="text-2xl font-bold text-[#1A1A1A]">Data Sources</h1>
        <p class="text-sm text-[#6B7280] mt-1">
          Upload files for your solutions to use.
        </p>
      </header>

      <app-data-management-card
        [buttonsKeys]="modules_additional"
        [tabRoute]="modules[0].tabRoute"
        (datasetName)="setDataSourceName($event)"
        [additionalIconBool]="true"
      ></app-data-management-card>

      <app-data-management-card
        [buttonsKeys]="modules[0]['buttonName']"
        [tabRoute]="modules[0].tabRoute"
        (datasetName)="setDataSourceName($event)"
      ></app-data-management-card>
    </div>
  `,
  styleUrls: ['./configure-data-source.component.scss'],
})
export class ConfigureDataSourceComponent implements OnInit {
  dataType = 'additional';

  modules: Module[] = [
    {
      key: 'additional',
      tabName: 'Data Sources',
      tabRoute: '/home/data_management/data_configuration/data_pull',
      buttonName: [],
    },
  ];

  modules_additional = [
    {
      btnName: 'Upload Files',
      btnDesc: 'Upload files from your local system',
      btnRoute: '/home/data_management/upload_files/',
      dataName: 'upload-file',
    },
  ];
  constructor(private dataManagementServices: DataManagementAppService) {}

  ngOnInit(): void {
    this.dataManagementServices
      .getConfiguredDataSource()
      .subscribe((data: any) => {
        data.map((item: any) => {
          let initialRoute =
            '/home/data_management/data_configuration/data_pull/';
          if (item?.source__connection_type_id == 'Files_Upload_(xlsx)') {
            initialRoute = '/home/data_management/upload_files/';
          }
          this.pushDataInAdditional(
            item.data_name,
            initialRoute,
            item.file_count,
            item.updated_dtm
          );
        });
      });
  }
  setDataType(dataType: string) {
    this.dataType = dataType;
  }

  pushDataInAdditional(
    name: string,
    routeUrl: string,
    fileCount?: number,
    updatedDtm?: string
  ) {
    let dataset: {
      btnName: string;
      btnRoute: string;
      dataName: string;
      fileCount?: number;
      updatedDtm?: string;
    } = {
      btnName: name,
      btnRoute: routeUrl,
      dataName: name,
      fileCount: fileCount,
      updatedDtm: updatedDtm,
    };
    this.modules[0].buttonName.push(dataset);
  }

  setDataSourceName(data: string) {
    this.dataManagementServices.setDataType(this.dataType);
  }
}
